import { useEffect } from 'react'
import useUserSession from 'src/hooks/useUserSession'
import useRedirectAfterLogin from 'src/hooks/useRedirectAfterLogin'

const TemAuthRedirect = () => {
  const { authenticated } = useUserSession()
  const redirectAfterLogin = useRedirectAfterLogin()

  useEffect(() => {
    if (authenticated) redirectAfterLogin({ redirectUrl: '/doctor' })
  }, [])

  return null
}

export default TemAuthRedirect
